/** Prefixo das queries de grupos de cliente; invalidar ele atualiza o select e a lista da importação. */
export const customerGroupsQueryKey = ["customer-groups"] as const;
